/**
 * routes/proveedor/ProveedorIcons.jsx -- Íconos SVG inline del Portal de
 * Proveedores. Las acciones operativas usan Material Symbols compartidos;
 * los de acceso, estado y detalle se agrupan aquí: un solo trazo por
 * significado, heredan `currentColor`.
 */
const PATHS = {
  user: 'M12 12a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9ZM4 21v-1.5C4 16.5 8 15 12 15s8 1.5 8 4.5V21',
  lock: 'M6 11h12v10H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3',
  close: 'M6 6l12 12M18 6L6 18',
  info: 'M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18ZM12 11v5M12 8v.01',
  alert: 'M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18ZM12 7.5v5.5M12 16.5v.01',
  check: 'M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18ZM8 12.5l2.8 2.8L16 10',
  clock: 'M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18ZM12 7v5l3 3',
  box: 'M3 7.5L12 3l9 4.5v9L12 21l-9-4.5zM3 7.5l9 4.5l9-4.5M12 12v9',
  logout: 'M12 3v8M6.3 6.6a8 8 0 1 0 11.4 0',
  search: 'M11 4a7 7 0 1 0 0 14a7 7 0 0 0 0-14ZM20 20l-4-4',
  route: 'M6 19a2 2 0 1 0 0-4a2 2 0 0 0 0 4ZM18 9a2 2 0 1 0 0-4a2 2 0 0 0 0 4ZM6 15V9a4 4 0 0 1 4-4h6M18 9v6a4 4 0 0 1-4 4H8',
  chart: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  sun: 'M12 8a4 4 0 1 0 0 8a4 4 0 0 0 0-8ZM12 2v2M12 20v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M2 12h2M20 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4',
  moon: 'M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5Z',
  save: 'M5 4h11l3 3v13H5zM8 4v5h7V4M8 14h8v6',
  lockReset: 'M6 11h12v10H6zM8.5 11V8a3.5 3.5 0 0 1 6.8-1.3M17 5.3V8h-2.4',
};

export default function Icon({ name, size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d={PATHS[name]} />
    </svg>
  );
}
